import {
    ToolOutlined,
    SettingOutlined,
    DashboardOutlined,
    GiftOutlined,
    CustomerServiceOutlined,
    BorderOutlined,
    MoneyCollectOutlined,
    DesktopOutlined,
    TeamOutlined,
    ScheduleOutlined,
    CrownOutlined,
  } from '@ant-design/icons';
  
  const IconMap: Record<string, any> = {};
  IconMap.customer = <CustomerServiceOutlined />;
  IconMap.member = <GiftOutlined />;
  IconMap.admin = <CrownOutlined />;
  IconMap.order = <BorderOutlined />;
  IconMap.tools = <ToolOutlined />;
  IconMap.team = <TeamOutlined />;
  IconMap.finance = <MoneyCollectOutlined />;
  IconMap.dashboard = <DashboardOutlined />;
  IconMap.oa = <DesktopOutlined />;
  IconMap.educational = <ScheduleOutlined />;
  IconMap.settings = <SettingOutlined />;
  
  export default IconMap;
  